import { redirectRoute } from './helpers';
import App from '../components/App';
import { PointStages } from '../constants/AppConstants';
import AppActions from '../actions/AppActions';

// Helper to unwrap ES module default
const unwrap = (mod) => (mod && mod.default) || mod;

const childRoutes = [
    unwrap(require('./Point/Init')),
    unwrap(require('./Point/Search')),
    unwrap(require('./Point/Results')),
    unwrap(require('./Point/SearchResults')),
    unwrap(require('./ServiceList')),
    unwrap(require('./Grid/Services')),

    unwrap(require('./Checkout/Delivery')),
    unwrap(require('./Checkout/Payment')),
    unwrap(require('./Checkout/PaymentConfirmation')),

    unwrap(require('./Account')),
    unwrap(require('./Account/Smartcard/AssociationConfirmation')),

    unwrap(require('./Season/Init')),
    unwrap(require('./Season/Search')),
    unwrap(require('./Season/Results')),

    unwrap(require('./OtherTickets')),
    unwrap(require('./DaySave/Search')),
    unwrap(require('./DaySave/Results')),
    unwrap(require('./RoversRangers/Search')),
    unwrap(require('./RoversRangers/Results')),

    unwrap(require('./Promotion/TOCFamily')),
    unwrap(require('./Promotion/Verify')),
    unwrap(require('./Promotion')),
    unwrap(require('./Promotion/Apply')),

    unwrap(require('./Login/Reset')),
    unwrap(require('./Login/SetPasswordAndPreferences')),

    unwrap(require('./Newsletter/Unsubscribe')),

    unwrap(require('./NRE')),

    unwrap(require('./OtherPages')),

    unwrap(require('./InApp')),

    unwrap(require('./WidgetAuth')),

    unwrap(require('./HandOff/Fare')),

    unwrap(require('./SelfSmartcard')),

    unwrap(require('./DisruptionAlerts')),

    unwrap(require('./TimetableAlerts')),

    unwrap(require('./Widget/RefundWidget')),

    //Any not found route goes to search
    redirectRoute('/**', PointStages.SEARCH)
].filter((x) => !!x);

const rootRoute = {
    component: App,
    path: '/',

    indexRoute: redirectRoute(null, PointStages.SEARCH),

    onEnter({ location }) {
        if (location.query) {
            const featureFlags = Object.keys(location.query)
                .filter((param) => param.startsWith('feature.'));
            featureFlags.forEach((param) => {
                const feature = param.replace('feature.', '');
                const featureValue = location.query[param];
                AppActions.toggleFeature(
                    feature,
                    !!featureValue.match(/^(?:yes|true|on|1)$/i)
                );
            });
        }
    },

    childRoutes,
};

export default rootRoute;
